import { vuexHandbook } from '@/store/composition/handbook'
import { UserDepartmentApi } from '@/api/handbook/user/UserDepartment/UserDepartmentApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: UserDepartmentApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
